import React from 'react';
import { Modal } from './ui/Modal';
import { Button } from './ui/Button';
import { MissingEntriesPayload } from '../types';

interface MissingEntriesModalProps {
  isOpen: boolean;
  onClose: () => void;
  content: MissingEntriesPayload;
}

export const MissingEntriesModal: React.FC<MissingEntriesModalProps> = ({ isOpen, onClose, content }) => {
  const { items, projectName, projectLocation } = content;
  
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Lançamentos Pendentes" size="md">
      <div>
        {projectName && (
          <div className="mb-4 p-3 bg-gray-100 dark:bg-dark-surface rounded-lg border border-gray-200 dark:border-dark-tertiary">
            <h4 className="font-bold text-lg text-gray-900 dark:text-dark-text-primary">{projectName}</h4>
            {projectLocation && <p className="text-sm text-gray-600 dark:text-dark-text-secondary">{projectLocation}</p>}
          </div>
        )}
        <p className="text-dark-text-secondary mb-4">Os seguintes itens não possuem lançamentos para o período selecionado:</p>
        <div className="bg-dark-surface p-3 rounded-md max-h-64 overflow-y-auto border border-dark-tertiary">
          <ul className="list-disc list-inside space-y-1 text-dark-text-primary">
            {items.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>
        <div className="flex justify-end mt-6">
          <Button onClick={onClose} variant="primary">
            Fechar
          </Button>
        </div>
      </div>
    </Modal>
  );
};